import { render, staticRenderFns } from "./CoShare.vue?vue&type=template&id=0cd3c16c&"
import script from "./CoShare.vue?vue&type=script&lang=ts&"
export * from "./CoShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports